@if(!userLoggedIn){
  <div class="pi_Breadcrumbs">
    <span class="br_Home_Txt">Home</span>
    <span class="br_Arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
        <path
          d="M4.406 5.114L0.16 0.868C0.0666665 0.774667 0.0166669 0.66 0.0100002 0.524C0.00333356 0.388 0.0533332 0.266667 0.16 0.16C0.266667 0.0533332 0.384667 0 0.514 0C0.643333 0 0.761333 0.0533332 0.868 0.16L5.256 4.549C5.34333 4.63567 5.40467 4.72467 5.44 4.816C5.47533 4.90733 5.493 5.00667 5.493 5.114C5.493 5.22133 5.47533 5.32067 5.44 5.412C5.40467 5.50333 5.34333 5.59267 5.256 5.68L0.868 10.068C0.774667 10.1613 0.66 10.2113 0.524 10.218C0.388 10.2247 0.266667 10.1747 0.16 10.068C0.0533332 9.96133 0 9.84333 0 9.714C0 9.58467 0.0533332 9.46667 0.16 9.36L4.406 5.114Z"
          fill="#2A3237" />
      </svg>
    </span>
    <span class="br_Pi_Txt">Prescribing information</span>
  </div>
}
<div class="container col-xs-12 col-sm-12 no-padding main_container" id="prescribingpage">
  <div class="container-fluid container-lg">
    @if (headerItems$ | async ; as item) {
      <div class="piheadersection">
        <div class="prescribeinfotext">
          {{ item.headLine1 }}
        </div>
        <div class="pititle">
          {{ item.subHeadLine1 }}
        </div>
        @if (prescribingProducts.length > 0) {
          <div class="flexbox">
            <div class="piseasonbox col-xs-6 margin-R20">
              <div class="seasonheader pipaddingbottom" [innerHTML]="prescribingProducts[0].headLine1"></div>
              <a class="piproductanchor pimarginbottom" href="#aujemsection" (click)="scrollToSection('aujemsection', $event)">
                <div class="piproduct"[innerHTML]="prescribingProducts[2].text1"></div>
              </a>
              <a class="piproductanchor pimarginbottom" href="#aTIVsection" (click)="scrollToSection('aTIVsection', $event)">
                <div class="piproduct" [innerHTML]="prescribingProducts[0].text1"></div>
              </a>
              <a class="piproductanchor" href="#TIVcsection" (click)="scrollToSection('TIVcsection', $event)">
                <div class="piproduct" [innerHTML]="prescribingProducts[0].text2"></div>
              </a>
            </div>
            <!-- <div class="piseasonbox col-xs-6 margin-L20">
            <div class="seasonheader pipaddingbottom" [innerHTML]="prescribingProducts[1].headLine1"></div>
            <a class="piproductanchor pimarginbottom" href="#aqivsection" (click)="scrollToSection('aqivsection', $event)">
              <div class="piproduct" [innerHTML]="prescribingProducts[1].text1"></div>
            </a>
            <a class="piproductanchor" href="#qivcsection" (click)="scrollToSection('qivcsection', $event)">
              <div class="piproduct" [innerHTML]="prescribingProducts[1].text2"></div>
            </a>
          </div> -->
        </div>
      }
    </div>
  }
  @for (item of contentProducts; track item; let i = $index) {
    <div class="picontentsection">
      <div class="pisubheader" [ngClass]="{'newproduct_piheader': sectionIds[i] === 'aTIVsection' || sectionIds[i] === 'TIVcsection' || sectionIds[i] === 'aujemsection'}" [id]="sectionIds[i]">{{ contentProducts[i].header1 }}</div>
      @if (contentProducts[i].subHeadline) {
        <div class="newproduct_spc">{{ contentProducts[i].subHeadline }}</div>
      }
      <div class="flexcont">
        <div class="piproducttext lefttext" [innerHTML]="contentProducts[i].LargeText"></div>
        <div class="piproducttext righttext">
          <div [innerHTML]="contentProducts[i].bottomText1"></div>
          <div class="legalcategory" [innerHTML]="contentProducts[i].MidText1"></div>
          <div class="forfull" [innerHTML]="contentProducts[i].MidText2"></div>
          <div class="flexelement smallscreendoc" [innerHTML]="contentProducts[i].Text1"></div>
        </div>
      </div>
      <div class="flexcont-adverse">
        <div class="adversetext">
          <span [innerHTML]="contentProducts[i]?.name"></span>&nbsp;
          <span (click)="openModal()" [innerHTML]="contentProducts[i]?.bottomText2" class="pi_Ext_Link"></span>&nbsp;
          <span [innerHTML]=" contentProducts[i]?.Text2 "></span>      
        </div>
        <button (click)="topFunction()" id="pi_backtop" title="Go to top">
          <i class="fa fa-long-arrow-up"></i>
          Back to Top
        </button>
      </div>
    </div>
  }
</div>
</div>

<!--External link POP up-->
<div class="commonleaving_abandonedPop modal pi_commonleaving_abandonedPop" role="dialog" data-bs-backdrop="static" id="pi_commonleaving_abandonedPop">
  <div class="knowledgeHub_abandonedPopContent">
    <div class="knowledgeHub_abandonedPopHeader">
      <div class="knowledgeHub_abandonedPopTitle">{{popupdata?.headline}}</div>
      <div class="knowledgeHub_abandonedPopClose" (click)="closeModal()">X</div>
      <div class="clearboth"></div>
    </div>
    <div class="knowledgeHub_abandonedPopText">
      <p [innerHTML]="popupdata?.message1" class="popup_Text1"></p>
      <p [innerHTML]="popupdata?.message2" class="popup_Text1"></p>
    </div>
    <div class="knowledgeHub_abandonedPopBtns">
      <a class="knowledgeHub_abandonedPopBtn commonleave_popContBtn" href="{{popupdata?.link}}" target="_blank" (click)="closeModal()">{{popupdata?.label1}}</a>
      <button class="knowledgeHub_abandonedPopBtn knowledgeHub_popCanceltBtn"
        (click)="closeModal()">{{popupdata?.label2}}</button>
    </div>
    <div class="knowledgedocnumberUk">{{popupdata?.jobBagCode}}</div>
  </div>
</div>